export const PROJECT_TYPE = 'projects' as const;
export const ISSUE_TYPE = 'issues' as const;
export const FILTER_TYPE = 'filters' as const;
export const DASHBOARD_TYPE = 'dashboards' as const;
export const QUEUE_TYPE = 'queues' as const;
export const BOARD_TYPE = 'boards' as const;
export const JWM_BOARD_TYPE = 'jwmBoards' as const;
export const ADDON_TYPE = 'addons' as const;
export const PLAN_TYPE = 'plans' as const;
export const ALERT_TYPE = 'alerts' as const;
